export const APP_VERSION = "v1.15.0";

// Owner playbook: when you ship a major feature, add its nav id here and bump
// APP_VERSION. A teal "NEW" pill shows next to it until the member clicks it.
// Remove ids from this list once a feature is no longer "new".
export const NEW_FEATURES = ["history", "timeoff", "settings"];

const KEY = "pr.seen.features";

export const getSeenFeatures = () => {
  try {
    return new Set(JSON.parse(localStorage.getItem(KEY) || "[]"));
  } catch {
    return new Set();
  }
};

export const markFeatureSeen = (id) => {
  try {
    const s = getSeenFeatures();
    s.add(id);
    localStorage.setItem(KEY, JSON.stringify([...s]));
  } catch (_e) { /* storage unavailable */ }
};

// Changelog entries live in /app/backend/changelog.py, the single source of
// truth. They're served at GET /api/whats-new (powers the /whats-new page) and
// mirrored into the monthly member announcement email
// (POST /api/admin/whats-new-email). Keep APP_VERSION above in sync.
